import { Form, Input, Button, Row, Col, Card, ConfigProvider } from 'antd';
import { connect } from 'react-redux';
import { EnvironmentOutlined } from '@ant-design/icons';
import SelectField from '../shared/SelectField';
import InputField from '../shared/InputField';
import SubmitBtn from '../shared/SubmitBtn';
import Utility, { notifyType, notifyPlacement } from '../../helper/utility';
import handleRsponse from '../../helper/handleRsponse';
import React, { useEffect, useState } from 'react';
import customerRepo from '../../repository/customerRepo';
import basicInfoRepo from '../../repository/basicInfoRepo';
import { userActions } from '../../redux/actions/userAction';
const { TextArea } = Input;
const RegisterAddress = (props) => {
    const provideChangedAddress=(obj)=>{
        return {
            customerId:obj.customerId,
            address:obj.lastAddress,
            mobile:obj.mobile,
            provinceId:(obj.provinceId==0)?'':obj.provinceId,
            cityId:(obj.cityId==0)?'':obj.cityId,
            regionId:(obj.regionId==0)?'':obj.regionId,
            parishId:(obj.parishId==0)?'':obj.parishId
        }
    }
    const [isLoaded, setIsLoaded] = useState(true);
    const [provinceCodeList, setProvinceList] = useState([]);
    const [cityCodeList, setCityList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [parishList, setParishList] = useState([]);
    const [currUser, setCurrUSer] = useState(provideChangedAddress(props.currentUser));
    const formRef = React.createRef();
    useEffect(() => {
        handleRsponse.handleAxios(basicInfoRepo.getList('typeId=1&parentId=0'), fillProvince, setIsLoaded);
        if (parseInt(currUser.provinceId) > 0) {
            handleProvinceSelect(currUser.provinceId);
            handleCitySelect(currUser.cityId);
            handleRegionSelect(currUser.regionId);
            formRef.current.setFieldsValue({
                cityId: currUser.cityId,
                regionId: currUser.regionId,
                parishId: currUser.parishId
            });
        }
    }, []);

    const fillProvince = (response) => {
        handleApiResult(response, 'fillProvince');
    }
    const fillCity = (response) => {
        handleApiResult(response, 'fillCity');
    }
    const fillRegion = (response) => {
        handleApiResult(response, 'fillRegion');
    }
    const fillParish = (response) => {
        handleApiResult(response, 'fillParish');
    }
    const handleApiResult = (response, actionType) => {
        if (response.status === 200) {
            switch (actionType) {
                case 'fillProvince':
                    setProvinceList(response.data.data);
                    break;
                case 'fillCity':
                    setCityList(response.data.data);
                    break;
                case 'fillRegion':
                    setRegionList(response.data.data);
                    break;
                case 'fillParish':
                    setParishList(response.data.data);
                    break;
                default:
                    break;
            }
        }

        else
            Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', response.data);
    }
    const provideCurrentUser=(values)=>{
        let updatedUser=props.currentUser;
        updatedUser.lastAddress=values.address;
        updatedUser.provinceId=values.provinceId;
        updatedUser.cityId=values.cityId;
        updatedUser.regionId=values.regionId;
        updatedUser.parishId=values.parishId;
        updatedUser.firstName=values.firstName;
        updatedUser.lastName=values.lastName;
        updatedUser.homeTel=values.homeTel;
        return updatedUser;
    }    
    const onFinish = (values) => {
        console.log('Success:', values);
        if (props.currentUser.lastAddress === '') {
            //let x=provideCurrentUser(values);                       
            props.updateCurrentUser(provideCurrentUser(values));
            goToRegisterService();
        }

        else
            changeAddress(values);
    };
    const changeAddress = (values) => {
        let updatedUser=provideCurrentUser(values);
        props.updateCurrentUser( updatedUser);             
        setCurrUSer(provideChangedAddress(updatedUser));               
        let changedObj=provideChangedAddress(updatedUser);
        handleRsponse.handleAxios(customerRepo.changeAddress(changedObj, props.currentUser.token), afterChange, setIsLoaded)
    }
    const afterChange = (response) => {
        
        if (response.status === 200) {
            setTimeout(() => { goToRegisterService(); }, 100);
        }
        else
            Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', response.data);
    }
    const goToRegisterService = () => {
        props.history.push('/registerService');
    }
    const handleProvinceSelect = (value) => {
        formRef.current.setFieldsValue({
            cityId: null,
            regionId: null,
            parishId: null
        });
        handleRsponse.handleAxios(basicInfoRepo.getList(`typeId=2&parentId=${value}`), fillCity, setIsLoaded);
        setRegionList([]);
        setParishList([]);
    }
    const handleCitySelect = (value) => {
        formRef.current.setFieldsValue({
            regionId: null,
            parishId: null
        });
        handleRsponse.handleAxios(basicInfoRepo.getList(`typeId=3&parentId=${value}`), fillRegion, setIsLoaded);
        setParishList([]);
    }
    const handleRegionSelect = (value) => {
        formRef.current.setFieldsValue({
            parishId: null
        });
        handleRsponse.handleAxios(basicInfoRepo.getList(`typeId=4&parentId=${value}`), fillParish, setIsLoaded);
    }
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <ConfigProvider direction="rtl">
            <Card>
                <Form
                    ref={formRef}
                    name="basic"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    initialValues={currUser}                    
                >
                    {(props.currentUser.lastAddress === '') ?
                        <div>
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <InputField name="mobile" label="موبایل" req={true} placeholder="موبایل" disabled={true} />
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <InputField name="homeTel" label="تلفن ثابت" req={true} maxLength={11} placeholder="تلفن ثابت" />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <InputField name="firstName" label="نام" req={true} placeholder="نام" />
                                </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <InputField name="lastName" label="نام خانوادگی" req={true} placeholder="نام خانوادگی" />
                                </Col>
                            </Row>
                        </div> : ''
                    }
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <SelectField name="provinceId" label="استان" placeholder="استان" list={provinceCodeList}
                                handleParent={(value) => { handleProvinceSelect(value) }}
                            />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <SelectField name="cityId" label="شهر" placeholder="شهر" list={cityCodeList}
                                handleParent={(value) => { handleCitySelect(value) }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <SelectField name="regionId" label="منطقه" placeholder="منطقه" list={regionList}
                                handleParent={(value) => { handleRegionSelect(value) }}
                            />
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <SelectField name="parishId" label="محله" placeholder="محله" list={parishList} />
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <InputField name="address" label="آدرس" placeholder="آدرس" inputType='TextArea' />
                        </Col>
                    </Row>
                    <Form.Item
                        wrapperCol={{
                            offset: 0,
                        }}
                    >
                        <SubmitBtn label={(props.currentUser.lastAddress !== '') ? "تغییر آدرس" : 'مرحله بعد'} />
                        {(props.currentUser.lastAddress !== '') ?
                            <Button type="primary" danger htmlType="button" style={{ float: "left" }} onClick={goToRegisterService} >
                                تایید آدرس
                            </Button> : ''
                        }


                    </Form.Item>

                </Form>
            </Card>
        </ConfigProvider>
    );
}
const mapStateToProps = state => ({
    logined: state.user.isAuthenticate,
    cc: state.user.currentCustomerInfo,
    serviceTypeId: state.user.currentServiceTypeId,
    currentMobile: state.user.currentMobile,
    currentUser: state.user.currentUser
});
const mapActionCreateor = {
    //setCustomer: userActions.updateCurrentCustomer,
    updateCurrentUser: userActions.setCurrentUser,
}
export default connect(mapStateToProps, mapActionCreateor)(RegisterAddress)
